import { render, staticRenderFns } from "./MarketProductTableVariantTitle.vue?vue&type=template&id=90fe0444&"
import script from "./MarketProductTableVariantTitle.vue?vue&type=script&lang=js&"
export * from "./MarketProductTableVariantTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports